import {createSelector} from 'reselect';
import {getSystem, getTravelerFeatures, getTripData} from './store';
import {
    getArrivedFromExternalSite,
    getHasCookiedGeoString,
    getArrivedFromEmail,
    getArrivedFromFacebook
} from '../utils/travelerSegments';

const getTravelerSegments = createSelector(
    [getSystem, getTravelerFeatures, getTripData],
    (system, travelerFeatures, tripData) => {
        const {referer, hostName, queryParamsOnEntry, cookies, environment} = system;
        const {isLoggedIn} = travelerFeatures;
        const {arrivedWithoutDates} = tripData;

        const arrivedFromEmail = getArrivedFromEmail(queryParamsOnEntry);
        const arrivedFromExternalSite = getArrivedFromExternalSite(referer, hostName, environment);
        const arrivedFromFacebook = getArrivedFromFacebook(queryParamsOnEntry);
        const hasRecentGeoSearch = getHasCookiedGeoString(cookies);
        const coldStartUser =
            arrivedFromExternalSite && !isLoggedIn && !arrivedFromEmail && !hasRecentGeoSearch;

        const travelerSegments = {
            arrivedFromEmail,
            arrivedFromExternalSite,
            arrivedFromFacebook,
            arrivedWithoutDates,
            hasRecentGeoSearch,
            isLoggedIn,
            coldStartUser
        };
        return travelerSegments;
    }
);
const getTravelerSegmentFeatures = createSelector(
    [getTravelerSegments, getTripData],
    (travelerSegments, tripData) => {
        const {
            arrivedFromExternalSite,
            arrivedFromFacebook,
            arrivedWithoutDates,
            coldStartUser,
            hasRecentGeoSearch
        } = travelerSegments;
        const {arriveDateText, departDateText} = tripData;
        const hasDates = arriveDateText && departDateText;

        return {
            showLastSearchedLocation: !arrivedFromExternalSite && hasRecentGeoSearch,
            showTopRecoCarousel: coldStartUser,
            showMidpageRecoCarousel: coldStartUser,
            usePrimarySearchBoxSubmit: coldStartUser,
            hideSearchBoxGuestsMobile: coldStartUser,
            showBackToSerp: coldStartUser,
            useCheckAvailabilityButton: coldStartUser && arrivedWithoutDates,
            redirectToPinnedSerpOnDateEntry:
                coldStartUser && arrivedWithoutDates && !arrivedFromFacebook && !hasDates,
            showExpandedSearchForm: coldStartUser
        };
    }
);

export {getTravelerSegments, getTravelerSegmentFeatures};
